
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#12171C","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Size=20"}},[_c('path',{attrs:{"id":"Vector","d":"M3.21 4.368L2.735 4 2 4.948l.475.367L16.79 16.43l.475.368.735-.948-.475-.367-2.423-1.88c1.048-1.1 1.755-2.348 2.1-3.204-.75-1.867-3.24-5.6-7.2-5.6-1.674 0-3.081.665-4.209 1.575L3.21 4.368zm4.353 3.38a3.601 3.601 0 015.61 4.356l-.966-.753a2.4 2.4 0 00-2.673-3.308l.29 1.455-2.26-1.75zm3.763 5.998a3.602 3.602 0 01-4.89-3.853L4.143 8.086c-.638.84-1.09 1.682-1.343 2.313.75 1.867 3.24 5.6 7.201 5.6a6.333 6.333 0 003.123-.835l-1.798-1.418zm-1.325-.947c.04 0 .08 0 .12-.003l-2.478-1.952a2.4 2.4 0 002.358 1.955z"}})])])
          )
        }
      }
    